module.exports = __webpack_public_path__ + "static/media/10-Liechtenstein@2x.8b1f1968.jpg";